export const SUBMIT_FORM = "SUBMIT_FORM";
export const GET_COORDINATES = "GET_COORDINATES";
export const RESET_MAP = "RESET_MAP";
export const GA_FORM_EVENT = "GA_FORM_EVENT"
export const GA_PAGE_VIEW = "GA_PAGE_VIEW"


// WEBPACK FOOTER //
// ./src/actions/types.js